export default {
  DELIVERY_ORDERS_LOAD: 'DELIVERY_ORDERS_LOAD',
  DELIVERY_ORDERS_FETCHED: 'DELIVERY_ORDERS_FETCHED',
  DELIVERY_BUTTON_LOADING: 'DELIVERY_BUTTON_LOADING',
  DELIVERY_DETAIL_LOAD: 'DELIVERY_DETAIL_LOAD',
  DELIVERY_DETAIL_FETCHED: 'DELIVERY_DETAIL_FETCHED',
  DELIVERY_GROCERY_LIST_LOAD: 'DELIVERY_GROCERY_LIST_LOAD',
  DELIVERY_GROCERY_LIST_FETCHED: 'DELIVERY_GROCERY_LIST_FETCHED',
};
